import * as React from "react"
import Slider from "react-slick"
import { TextWith4Covers } from "../../../../custom_api/collection/api"
import { Link } from "../../library/link"
import { scrollAdviceIntoView } from "../Advice/Advice"

type BookSliderProps = {
  popularThemes: TextWith4Covers[]
  pushDataLayer: (action: string, label: string) => void
  routePath: string,
  selectionPrompt?: string
}

export default class BookSlider extends React.Component<BookSliderProps> {
  render() {
    const { popularThemes, pushDataLayer, routePath, selectionPrompt } = this.props
    let timeout;

    const handleBeforeChange = () => {
      const sliderElement = document.querySelector(".slick-slider")
      if (sliderElement) {
        sliderElement.classList.remove("interaction-active")
        clearTimeout(timeout)
      }

      timeout = setTimeout(() =>
        sliderElement && sliderElement.classList.add("interaction-active"), 5000)
    }

    const handleAfterChange = (index) => {
      const sliderElement = document.querySelector(".slick-slider")
      index ? sliderElement?.classList.add('highlighted') : sliderElement?.classList.remove('highlighted')
    }

    const settings = {
      accessibility: true,
      dots: false,
      className: 'interaction-active',
      arrows: false,
      infinite: false,
      variableWidth: true,
      speed: 500,
      swipeToSlide: true,
      draggable: true,
      slidesToShow: 4,
      swipe: true,
      beforeChange: handleBeforeChange,
      afterChange: index => handleAfterChange(index)
    };

    return (
      <div className="block block--slider-book slider">
        <div className="slider__inner">
          <div className="slider__content slider__line">
            {selectionPrompt && <div className="layout__header ip__header--bookslider">
              <h2 className="layout__title layout__title--center title--s">{selectionPrompt}</h2>
            </div>}
            <Slider {...settings}>
              {popularThemes.map(theme =>
                <Link
                  key={"link_" + theme.name}
                  className="slider__item-link"
                  handle={() => {
                    pushDataLayer("Klik op onderwerp suggestie", theme.name);
                    scrollAdviceIntoView();
                  }}
                  url={`/${routePath}/thema/${theme.name}`}
                >
                  <span className="slider__name">{theme.name}</span>
                  <div className="slider__visual">
                    <div className="slider__visual-visuals">
                      {theme.covers.length > 0 ?
                        theme.covers.map((x) => <img key={"img_" + x} className="slider__image" src={`${x ? x : "/book-foto.png"}`} width="105" height="150" alt={"Foto van het boek"} />) :
                        <>
                          <img className="slider__image" src="/book-foto.png" width="105" height="150" alt={"Foto van het boek"} />
                          <img className="slider__image" src="/book-foto.png" width="105" height="150" alt={"Foto van het boek"} />
                          <img className="slider__image" src="/book-foto.png" width="105" height="150" alt={"Foto van het boek"} />
                          <img className="slider__image" src="/book-foto.png" width="105" height="150" alt={"Foto van het boek"} />
                        </>
                      }
                    </div>
                  </div>
                </Link>)}
            </Slider>
          </div>
        </div>
      </div>
    )
  }
}
